import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { CustomerStateReportActions } from "./index";
import { initialCustomerStatementState } from "./CustomerStatementReport";
import { CLEAR_CUSTOMER_STATEMENT_STATE, FETCH_CUSTOMER_STATEMENT_LIST_FAILURE, FETCH_CUSTOMER_STATEMENT_LIST_PROGRESS, FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS } from "./CustomerStateReportActions";


export const customerStatementReportReducer = (
  state: IStoreState["accounting"]["customerStatement"] = initialCustomerStatementState,
  action: CustomerStateReportActions
) => {
  switch (action.type) {
    case FETCH_CUSTOMER_STATEMENT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
      });
      return newState;
    }

    case FETCH_CUSTOMER_STATEMENT_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_CUSTOMER_STATEMENT_STATE: {
      return initialCustomerStatementState;
    }

    default:
      return state;
  }
};
